import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";

const About = () => {
  const homeMenu = [
    { label: "Vision", link: "/about" },
    {
      label: "Management",
      link: "",
      subMenu: [
        { label: "Patron’s Message", link: "/patrons" },
        { label: "Director's Message", link: "/DirectorMessage" },
        { label: "Principal's Message", link: "/PrincipalMessage" },
        { label: "Leadership Team", link: "/leadershipTeam" },
        { label: "Advisory Board", link: "/advisoryBoard" },
      ],
    },

    { label: "International Collaborations", link: "/partnership" },
    // { label: "Awards & Achievements", link: "/awardsAcheivements" },

{
      label: "Awards & Achievements",
      link: "/awardsAcheivements",
      subMenu: [
        { label: "Accolades & Achievements", link: "/awardsAcheivements" },
        { label: "Students Achievements", link: "/studentsAcheivements" },
      ],
    },

    { label: "Faculty", link: "/faculty" },
    { label: "Staff Details", link: "/staffDetails" },
    { label: "School Strength ", link: "/schoolStrength" },
    {
      label: "Gallery",
      link: "/Gallery",
      subMenu: [
        { label: "Photo Gallery", link: "/Gallery" },
        { label: "Video Gallery", link: "/VideoGallery" },
      ],
    },
  ];
  return (
    <>
      <Header />
      <Breadcrumb breadImage="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/banner-faculty.jpg" />
      <Menu MenuItem={homeMenu} />
      <div className="padding-blk inner-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <PageTitle
                pageTitle="Faculty"
                breadEnd="Faculty"
                breadMid="Faculty"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div class="text-box">
                <p>“The art of teaching is the art of assisting discovery.”</p>
                <p>
                  We understand that a teacher introduces the learners to
                  success. Lotus Valley International School has an excellent
                  team of professional and highly-qualified educators who are
                  determined to enlighten the lives of our learners. Passionate,
                  creative and innovative individuals with excellent
                  communication skills and fire in their belly, the teachers are
                  partners in the progress of learners.
                </p>
                <p>
                  Regular updates help them keep pace with the new trends and
                  teaching methodologies like ‘Smart Board technology’ to aid
                  the learning of children. The staff attends regular seminars
                  and workshops on professional development, computer-aided
                  learning and software packages specially designed to support
                  the curriculum. The teachers are facilitators who guide our
                  learners through discovery with inspiration and motivation.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default About;
